import { get, post, put, Delete } from "../axios";

// 试卷管理-试卷列表
export const questionTestList = (params) => get("/web/question/test/list", params);

// 试卷管理-新增
export const questionTestAdd = (params) => post("/web/question/test/add", params);

// 试卷管理-编辑
export const questionTestUpdate = (params) => put("/web/question/test/update", params);

// 试卷管理-删除
export const questionTestDelete = (id) =>
    Delete("/web/question/test/delete/" + id, "");

// 试卷管理-详情
export const questionTestView = (id) => get("/web/question/test/view/" + id, "");

// 试卷管理-状态编辑
export const questionTestStateUpdate = (params) =>
    put("/web/question/test/state/update", params);

// 试卷管理-视频列表
export const questionTestVideoList = (params) => get("/web/question/test/video/list", params);


// 试卷管理-视频新增
export const questionTestVideoAdd = (params) => post("/web/question/test/video/add", params);

// 试卷管理-视频删除
export const questionTestVideoDelete = (id) =>
    Delete("/web/question/test/video/delete/" + id, "");